import { config, passport } from '@imtbl/sdk';
import { immutableConfig } from './config';

// Derive environment from config
const environment = immutableConfig.environment === 'production' 
  ? config.Environment.PRODUCTION 
  : config.Environment.SANDBOX;

// Base URI for logout (without /auth/callback)
const baseUri = immutableConfig.redirectUri.replace('/auth/callback', '');

// Build passport configuration
const passportConfig = {
  baseConfig: {
    environment: environment,
  },
  clientId: immutableConfig.clientId,
  redirectUri: immutableConfig.redirectUri,
  logoutRedirectUri: baseUri,
  audience: 'platform_api',
  scope: 'openid offline_access email transact'
};

// Only add publishableKey if provided
if (immutableConfig.publishableKey && immutableConfig.publishableKey.startsWith('pk_')) {
  passportConfig.baseConfig.publishableKey = immutableConfig.publishableKey;
}

const passportInstance = new passport.Passport(passportConfig);

// Debug logging for sandbox environment
if (immutableConfig.environment === 'sandbox') {
  console.log('Passport Debug Mode Enabled');
  console.log('Environment:', immutableConfig.environment);
  console.log('Client ID:', immutableConfig.clientId);
  
  window.addEventListener('message', (event) => {
    if (event.origin === 'https://auth.immutable.com') {
      console.log('[imx] Passport Event:', event.data);
    }
  });
}

export default passportInstance;